import React, { useMemo } from 'react';
import MobileFormResponsesContainer from '../../formResponses/MobileFormResponsesContainer';
import { getPortfolioFormName, buildPropertiesMap } from '../../../utils/formDisplayNames';

/**
 * Mobile Responses Tab Component
 * 
 * Refactored to use the new reusable FormResponsesContainer
 * This tab is part of the Capture Tools interface and displays all form responses
 * for a given property or portfolio context on mobile devices.
 */
const MobileResponsesTab = ({ propertyTab, portfolio }) => {
  // Shared name derivation — same as QR Generator & Automations
  const propertiesMap = useMemo(
    () => buildPropertiesMap(propertyTab?.properties),
    [propertyTab?.properties],
  );

  const portfolioName = getPortfolioFormName(portfolio?.data);

  return (
    <div className="space-y-4">
      <MobileFormResponsesContainer
        title="Form Submissions"
        propertiesMap={propertiesMap}
        portfolioName={portfolioName}
        onResponseSelected={(response) => {
          // Optional callback for when a response is selected
          console.log('[MobileResponsesTab] Response selected:', response);
        }}
      />
    </div>
  );
};

export default MobileResponsesTab;
